import { useEffect, useReducer, useState } from "react";
import { browserApi } from "../account/api";
import { createParentPage, parentActions, type ParsedAddress } from "../account/consent";
import type { ParentActions, ParentView } from "../ui/view-model";

/** The parents' page: no game is created, only the link check and the hand-off to Google. */
export function useParent(address: ParsedAddress): { view: ParentView; actions: ParentActions } {
  const [, refresh] = useReducer((n: number) => n + 1, 0);
  const [page] = useState(() =>
    createParentPage({ api: browserApi(), token: address.token, result: address.result, onChange: refresh, navigate: (url) => window.location.assign(url) }),
  );
  useEffect(() => {
    void page.start();
  }, [page]);
  return { view: page.view(), actions: parentActions(page) };
}
